import { render, staticRenderFns } from "./VariantWordsConfigurations.vue?vue&type=template&id=29266877&"
import script from "./VariantWordsConfigurations.vue?vue&type=script&lang=js&"
export * from "./VariantWordsConfigurations.vue?vue&type=script&lang=js&"
import style0 from "./VariantWordsConfigurations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports